import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

// Accordion
class AccordionCustom extends HTMLElement {
  /** @type {HTMLDetailsElement} */
  get details() {
    const details = this.querySelector('details');

    if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');

    return details;
  }

  /** @type {HTMLElement} */
  get summary() {
    const summary = this.details.querySelector('summary');

    if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');

    return summary;
  }

  get #disableOnMobile() {
    return this.dataset.disableOnMobile === 'true';
  }

  get #disableOnDesktop() {
    return this.dataset.disableOnDesktop === 'true';
  }

  get #closeWithEscape() {
    return this.dataset.closeWithEscape === 'true';
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.#setDefaultOpenState();

    this.addEventListener('keydown', this.#handleKeyDown, { signal });
    this.summary.addEventListener('click', this.handleClick, { signal });
    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange, { signal });
  }

  /**
   * Handles the disconnect event.
   */
  disconnectedCallback() {
    // Disconnect all the event listeners
    this.#controller.abort();
  }

  /**
   * Handles the click event.
   * @param {Event} event - The event.
   */
  handleClick = (event) => {
    const isMobile = isMobileBreakpoint();
    const isDesktop = !isMobile;

    // Stop default behaviour from the browser
    if ((isMobile && this.#disableOnMobile) || (isDesktop && this.#disableOnDesktop)) {
      event.preventDefault();
      return;
    }
  };

  /**
   * Handles the media query change event.
   */
  #handleMediaQueryChange = () => {
    this.#setDefaultOpenState();
  };

  /**
   * Sets the default open state of the accordion based on the `open-by-default-on-mobile` and `open-by-default-on-desktop` attributes.
   */
  #setDefaultOpenState() {
    const isMobile = isMobileBreakpoint();

    this.details.open =
      (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
      (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
  }

  /**
   * Handles keydown events for the accordion
   *
   * @param {KeyboardEvent} event - The keyboard event.
   */
  #handleKeyDown(event) {
    // Close the accordion when used as a menu
    if (event.key === 'Escape' && this.#closeWithEscape) {
      event.preventDefault();

      this.details.open = false;
      this.summary.focus();
    }
  }
}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}

/*
document.addEventListener("DOMContentLoaded", function () {

  const filterCheckboxes = document.querySelectorAll(
    'input[type="checkbox"][data-filter-value]'
  );

  const productCards = document.querySelectorAll(
    '[class*="product-grid"] > div'
  );

  function applyFilter() {
    const selectedFilters = Array.from(filterCheckboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.dataset.filterValue.toLowerCase());

    productCards.forEach(card => {
      const titleLink = card.querySelector("h3 a");
      if (!titleLink) return;

      const productTitle = titleLink.textContent.toLowerCase();

      const isMatch =
        selectedFilters.length === 0 ||
        selectedFilters.some(value => productTitle.includes(value));

      card.style.display = isMatch ? "" : "none";
    });
  }

  filterCheckboxes.forEach(cb =>
    cb.addEventListener("change", applyFilter)
  );

});
*/

document.addEventListener("DOMContentLoaded", function () {

  /* ===== LEFT FILTER CHECKBOXES ===== */
  const filterCheckboxes = document.querySelectorAll(
    '[class^="ai-filter-checkbox"]'
  );

  /* ===== RIGHT PRODUCT CARDS ===== */
  const productCards = document.querySelectorAll(
    '[class^="ai-product-card"]'
  );

  function applyDeviceFilter() {

    // Collect all selected device names
    const selectedDevices = Array.from(filterCheckboxes)
      .filter(cb => cb.checked)
      .map(cb => (cb.dataset.filterValue || "").toLowerCase());

    productCards.forEach(card => {

      const titleEl = card.querySelector(
        '[class^="ai-product-card-title"]'
      );

      if (!titleEl) return;

      const productText = titleEl.textContent.toLowerCase();

      // No filter selected → show all
      if (selectedDevices.length === 0) {
        card.style.display = "";
        return;
      }

      // Match ANY selected device name
      const matchFound = selectedDevices.some(device =>
        productText.includes(device)
      );

      card.style.display = matchFound ? "" : "none";
    });
  }

  // Bind change event
  filterCheckboxes.forEach(cb => {
    cb.addEventListener("change", applyDeviceFilter);
  });

});
